import 'react-circular-progressbar/dist/styles.css';
import HttpsRedirect from 'react-https-redirect';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import 'react-tooltip/dist/react-tooltip.css';
import initialState from 'redhotpie-shared-lib/reducers/initialState';
import configureStore from 'redhotpie-shared-lib/store/configureStore';
import * as myStore from 'redhotpie-shared-lib/store/myStore';
import { PersistGate } from 'redux-persist/integration/react';
import LoadingPage from './components/loading/LoadingPage';
import MainApp from './views/MainApp';

import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GOOGLE_TAG_KEY,
};
TagManager.initialize(tagManagerArgs);

// AWS amplify Face Liveness

myStore.init(configureStore, initialState);
const store = myStore.getStore();
const persistor = myStore.getPersistor();

const Root = () => {
  if (process.env.NODE_ENV === 'development') {
    return (
      <Provider store={store}>
        <PersistGate loading={<LoadingPage />} persistor={persistor}>
          <BrowserRouter>
            <Routes>
              <Route path={`*`} element={<MainApp />} />
            </Routes>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    );
  }
  return (
    <HttpsRedirect>
      <Provider store={store}>
        <PersistGate loading={<LoadingPage />} persistor={persistor}>
          <BrowserRouter>
            <Routes>
              <Route path={`*`} element={<MainApp />} />
            </Routes>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </HttpsRedirect>
  );
};

export default Root;
